import { ResourceType, useRefreshCollection } from 'json-api-hooks';
import React, { FC } from 'react';

import { ResourceFormProps } from '../components/./Form/ResourceForm';
import CardContent from '../components/Card/CardContent';
import CardMain from '../components/Card/CardMain';
import Container from '../components/Container';
import Heading from '../components/Heading';
import { ModalProps } from '../components/Modal/ModalContextProvider';
import useSnackbar from '../hooks/useSnackbar';

export type CreateResourceModalProps<T extends ResourceType> = ModalProps<{
  defaultValues?: Record<string, unknown>;
  label: string;
  type: T;
  form: FC<Partial<ResourceFormProps<T>>>;
  successMessage?: string;
}>;

const CreateResourceModal = <T extends ResourceType>({
  defaultValues,
  form: Form,
  handleClose,
  label,
  successMessage,
  type,
}: CreateResourceModalProps<T>) => {
  const showSnackbar = useSnackbar();
  const refreshCollection = useRefreshCollection();
  const handleSuccess = () => {
    refreshCollection(type);
    showSnackbar(successMessage ?? 'Het item is aangemaakt');
    handleClose();
  };

  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Heading>{label}</Heading>
          <Form defaultValues={defaultValues} onClose={handleClose} onSuccess={handleSuccess} />
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default CreateResourceModal;
